// Change PIXIPreload by necessary loader:
import {PIXIPreload} from '../../../../../viscomjs/load/PIXIPreload';
import {ResourceType} from '../../../../../viscomjs/load/ResourceType';
import {ManifestCreateJSToPIXI} from '../../../../../viscomjs/load/utils/ManifestCreateJSToPIXI';

const LoadImages = (manifest, doThat, progressUpdate, storage, config) => {
    return PIXIPreload(
        manifest instanceof Array ? ManifestCreateJSToPIXI(manifest) : {url: manifest, type: ResourceType.MANIFEST},
        config,
        doThat,
        progressUpdate,
        true,
        storage
    );
};

const LoadImagesFunction = (manifest, progressUpdate, storage, config) => {
    return doThat => {
        return LoadImages(manifest, doThat, progressUpdate, storage, config);
    };
};

export {LoadImages, LoadImagesFunction};
export default LoadImages;
